import http from "@/http-common";

class CognitoAuthService {
    decodeToken(data: any): Promise<any> {
        return http.api.post('/decodeToken/', data);
    }
}

export default new CognitoAuthService();